import { gql } from '@apollo/client';

export const CREATE_PET_SERVICE = gql`
  mutation CreatePetService($input: CreatePetServiceInput!) {
    createPetService(input: $input) {
      _id
      userId
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      createdAt
      updatedAt
      language
    }
  }
`;

export const UPDATE_PET_SERVICE = gql`
  mutation UpdatePetService($_id: ID!, $input: UpdatePetServiceInput!) {
    updatePetService(_id: $_id, input: $input) {
      _id
      userId
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      createdAt
      updatedAt
      language
    }
  }
`;

export const DELETE_PET_SERVICE = gql`
  mutation DeletePetService($_id: ID!) {
    deletePetService(_id: $_id) {
      _id
    }
  }
`;

